const CUENTAS_CORRIENTES_PARA_FINES_ESPECIFICOS = '1042'
const BANCO_DE_CREDITO_ME = '10412'
const INTERBANK_MN = '10413'
const BANCO_DE_CREDITO_MN = '10411'
const BANCO_DE_LA_NACION = '10419'

const __dictionary = {
  [INTERBANK_MN]: {
    id: INTERBANK_MN,
    nombre: '10413 - INTERBNAK. M.N.'
  },
  [BANCO_DE_CREDITO_MN]: {
    id: BANCO_DE_CREDITO_MN,
    nombre: '10411 - BANCO DE CREDITO M.N.'
  },
  [CUENTAS_CORRIENTES_PARA_FINES_ESPECIFICOS]: {
    id: CUENTAS_CORRIENTES_PARA_FINES_ESPECIFICOS,
    nombre: '1042 - Cuentas corrientes para fines específicos'
  },
  [BANCO_DE_CREDITO_ME]: {
    id: BANCO_DE_CREDITO_ME,
    nombre: '10412 - BANCO DE CREDITO M.E.'
  },
  [BANCO_DE_LA_NACION]: {
    id: BANCO_DE_LA_NACION,
    nombre: '10419 - BANCO DE LA NACION'
  }
}

const __array = [
  __dictionary[INTERBANK_MN],
  __dictionary[BANCO_DE_CREDITO_MN],
  __dictionary[CUENTAS_CORRIENTES_PARA_FINES_ESPECIFICOS],
  __dictionary[BANCO_DE_CREDITO_ME],
  __dictionary[BANCO_DE_LA_NACION]
]

export default Object.freeze({
  INTERBANK_MN,
  BANCO_DE_CREDITO_MN,
  CUENTAS_CORRIENTES_PARA_FINES_ESPECIFICOS,
  BANCO_DE_CREDITO_ME,
  BANCO_DE_LA_NACION,
  __dictionary,
  __array
})
